module.exports = __webpack_public_path__ + "static/media/archia-regular-webfont.44b223ad.ttf";